<template>
  <div
    class="p-6 min-h-screen flex justify-center items-center"
    style="--tw-bg-opacity: 1; background-image: url('background.png'); background-size: cover"
  >
    <div class="w-full max-w-md">
      <!-- <logo class="block mx-auto w-full max-w-xs fill-white" height="50" /> -->
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <img :src="'logo.jpg'" style="display: block; margin: 0 auto" alt="Logo" />
          <!-- <h1 class="text-center font-bold text-3xl">Welcome Back!</h1> -->
          <div class="mx-auto mt-6 w-24 border-b-2"></div>
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="mt-10"
            label="Email"
            type="email"
            autofocus
            autocapitalize="off"
          />
          <div class="password-field mt-6">
            <text-input
              v-model="form.password"
              :error="form.errors.password"
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              class="password-input"
            />
            <i
              :class="
                showPassword
                  ? 'fas fa-eye-slash password-toggle-icon'
                  : 'fas fa-eye password-toggle-icon'
              "
              @click="togglePasswordVisibility"
            ></i>
          </div>
          <label class="mt-6 select-none flex items-center">
            <a
              :href="route('forget.password.get')"
              class="text-green-700 no-underline hover:underline"
              >Esqueci minha senha</a
            >
          </label>
          <br />
          <flash-messages />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">
            Login
          </loading-button>
        </div>
      </form>
      <div class="mt-6 text-center">
        <a
          href="/PoliticadePrivacidade.pdf"
          download
          class="text-blue-500 underline"
          style="font-size: 1.225rem"
          >Baixar Política de Privacidade</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    // Logo,
    TextInput,
    FlashMessages,
  },
  data() {
    return {
      showPassword: false,
      form: {
        password: '',
        errors: {
          password: '',
        },
      },
      form: this.$inertia.form({
        email: null,
        password: null,
      }),
    }
  },
  created() {
    if (window.location.search.length > 0) {
      window.location.replace(this.route('login'))
    }
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
  },
}
</script>
<style scoped>
.password-field {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  width: 100%;
  padding-right: 30px; /* Espaço para o ícone */
}

.password-toggle-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #aaa;
  top: 60%;
}
</style>
